import React, { Component } from "react";
import { ListingContext } from "../../Context";
import _ from "lodash";

import { PrimaryColor } from "../../utils/consts";

import CheckIcon from "@atlaskit/icon/glyph/check";
import SkeletonText from "../../components/skeleton/SkeletonText";

export default class ListingIncluded extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const includedExpenses = listing.includedExpenses || {};
          if (listingContext.loading) {
            return (
              <div className="listing-included">
                <SkeletonText lines={5} />
              </div>
            );
          } else if (
            !_.isEmpty(includedExpenses) ||
            !!listing.furnished ||
            !!listing.locker ||
            !!listing.privateEntrance
          ) {
            return (
              <div className="listing-included">
                <h5 className="listing-section__title">
                  Included In The Lease
                </h5>
                <div className="listing-included__included">
                  {Object.keys(includedExpenses)
                    .filter(item => !!includedExpenses[item])
                    .map(item => (
                      <span
                        key={`listing-list__item_${item}`}
                        className="listing-list__item"
                      >
                        <span className="listing-item__icon">
                          <CheckIcon
                            small="small"
                            primaryColor={PrimaryColor}
                          />
                        </span>
                        {item.replace(/_/g, " ")}
                      </span>
                    ))}
                  {listing.furnished && (
                    <span
                      key={`listing-list__item_furnished`}
                      className="listing-list__item"
                    >
                      <span className="listing-item__icon">
                        <CheckIcon small="small" primaryColor={PrimaryColor} />
                      </span>
                      furnished
                    </span>
                  )}
                  {listing.locker && (
                    <span
                      key={`listing-list__item_locker`}
                      className="listing-list__item"
                    >
                      <span className="listing-item__icon">
                        <CheckIcon small="small" primaryColor={PrimaryColor} />
                      </span>
                      {listing.locker} locker
                    </span>
                  )}
                  {listing.privateEntrance && (
                    <span
                      key={`listing-list__item_private-entrance`}
                      className="listing-list__item"
                    >
                      <span className="listing-item__icon">
                        <CheckIcon small="small" primaryColor={PrimaryColor} />
                      </span>
                      {listing.privateEntrance}
                    </span>
                  )}
                  {listing.petsAllowed && (
                    <span
                      key={`listing-list__item_pets-allowed`}
                      className="listing-list__item"
                    >
                      <span className="listing-item__icon">
                        <CheckIcon small="small" primaryColor={PrimaryColor} />
                      </span>
                      {listing.petsAllowed}
                    </span>
                  )}
                </div>
              </div>
            );
          } else {
            return null;
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingIncluded.js